export const ADMIN_PANEL_ROLES_PATH = "/settings-menu/roles";
